module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-table"
  }, [(_vm.type === 1) ? _c('h2', [_vm._v("Produkt in Zahlen")]) : _vm._e(), _vm._v(" "), (_vm.type === 1) ? _c('div', {
    staticClass: "base"
  }, [_c('h3', [_vm._v("Stammdaten")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.template.table()), function(column) {
    return _c('div', {
      staticClass: "column"
    }, _vm._l((column), function(field) {
      return _c('div', {
        staticClass: "columns field"
      }, [_c('div', {
        staticClass: "column"
      }, [_c('strong', [_vm._v(_vm._s(field.title))])]), _vm._v(" "), _c('tablefield-' + field.type, {
        tag: "div",
        staticClass: "column",
        attrs: {
          "config": _vm.getFieldConfig(field),
          "data": _vm.getFieldData(field.path),
          "product": _vm.data
        }
      })], 1)
    }), 0)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.type === 2) ? _c('div', {
    staticClass: "figures"
  }, [_c('h3', [_vm._v("Rückzahlungsprofil")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.template.payback()), function(column) {
    return _c('div', {
      staticClass: "column"
    }, _vm._l((column), function(field) {
      return _c('div', {
        staticClass: "columns field"
      }, [_c('div', {
        staticClass: "column"
      }, [_c('strong', [_vm._v(_vm._s(field.title))])]), _vm._v(" "), _c('tablefield-' + field.type, {
        tag: "div",
        staticClass: "column",
        attrs: {
          "config": _vm.getFieldConfig(field),
          "data": _vm.getFieldData(field.path),
          "product": _vm.data
        }
      })], 1)
    }), 0)
  }), 0)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1362a00d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/BlockProductTableReport.vue
// module id = 657
// module chunks = 0